export const CHANGE_QUOTE_PARAMS = 'change_quote_params';
export const SET_COLUMNS = 'set_columns';
export const SET_QUOTE_ACTIVITY_DATA = 'set_quote_activity_data';
export const SET_QUOTE_ACTIVITY_BY_ID = 'set_quote_activity_by_id';
